/**
 * VERSIONE LIBRERIA 3.0
 */
var RenderBetweenDate = Render.extend({
    picker_selector : '[data-render_picker]',
    picker_end_selector : '[data-render_picker_end]',
    control_selector : '[data-render_control]',
    control_end_selector : '[data-render_control_end]',
    control_operator : '[data-render_operator]',

    type : 'between_date',
    classData : 'between_date',
    classTemplate : 'between_date',
    end_key : null,
    end_value : null,

    init : function (key,config) {
        this._super(key,config);
        if (!this.end_key)
            this.end_key = "end_" + this.key;
    },
    _validateEdit : function () {
        var self = this;
        if (!self.end_key)
            throw "end_key not definited!";
    },
    _renderEdit : function (jQe) {
        var self = this;

        var el = jQe.find(self.control_selector);
        el.attr("name", self.key).attr('value',self.value);
        var el = jQe.find(self.control_end_selector);
        el.attr("name", self.end_key).attr('value',self.end_value);
        self._setDateControl(jQe);
    },

    _renderSearch : function (jQe) {

    },
    _setDateControl : function (jQe) {
        var self = this;
        //var el = obj.find('[data-control_picker]');
        var el = jQe.find(self.picker_selector);
        el.attr("name", self.key + "_picker").attr("value", self.value);
        var el = jQe.find(self.picker_end_selector);
        el.attr("name", self.end_key + "_picker").attr("value", self.end_value);

    },


    _finalizeEdit : function () {
        var self = this;
        var key = self.key;
        var key_op = "";
        var currentDate = new Date();
        var endDate = new Date();
        if (self.value)
            currentDate = Utility.jsDate(self.value);
        endDate.setDate(currentDate.getDate()+1);

        if (self.end_value)
            endDate = Utility.jsDate(self.end_value);

        $(self.container).find(self.picker_selector).datepicker({
            autoclose : true,
            format: "dd-mm-yyyy",
        }).on('changeDate', function (ev) {
            var dbDate = Utility.dbDate(ev.date);
            dbDate = dbDate.split(' ')[0];
            log.debug("onChandeDate Start",dbDate);
            $(self.container).find(self.control_selector).val(dbDate);
            $(self.container).find(self.picker_end_selector).datepicker('setStartDate',ev.date);
        });
        $(self.container).find(self.picker_selector).datepicker('setDate',currentDate);

        $(self.container).find(self.picker_end_selector).datepicker({
            autoclose : true,
            startDate : currentDate,
            format: "dd-mm-yyyy"
        }).on('changeDate', function (ev) {
            var dbDate = Utility.dbDate(ev.date);
            dbDate = dbDate.split(' ')[0];
            log.debug("onChandeDate End",dbDate);
            $(self.container).find(self.control_end_selector).val(dbDate);
        });
        //console.log("end date",endDate);
        $(self.container).find(self.picker_end_selector).datepicker('setDate',endDate);
    },
    setValue : function (start,end) {
        var self = this;
        var container =  $(self.container);
        var dp = container.find('input[name="' + self.key + '_picker"]');
        dp.datepicker('setDate', start);
        var dp = container.find('input[name="' + self.end_key + '_picker"]');
        dp.datepicker('setDate', end);
    },
    getValue : function() {
        var self = this;
        var start =  $(self.container).find(self.control_selector).val();
        var end =  $(self.container).find(self.control_end_selector).val();
        return [start,end];
    }

});
